import { Injectable } from "@angular/core";
import { PaymentTypeParser } from "../parsers/pbm/benefit/payment-type.parser";

@Injectable()
export class PaymentRepository {
  constructor(
    private paymentTypeParser: PaymentTypeParser
  ) {}

  public getFormPayment(): any {
    const data = [{Key:"AUTOMATIC", Value:"Automático"},{Key:"AT_ACT", Value:"No Ato"}];

    return this.paymentTypeParser.parse(data);
  }
}
